const dataLogin={
    isAdmin: false,
    isUser: false,
    isLogin: false,
    forceRerenderHeader: null,
    loginState: null
}

export { dataLogin }